import { AxiosError, AxiosResponse } from "axios";
import { all, call, put, takeLatest } from "redux-saga/effects";
import {
  fetchTransferForeignCreateSuccess,
  fetchTransferForeignCreateFailure,
  fetchTransferForeignConfirmSuccess,
  fetchTransferForeignConfirmFailure,
  fetchTransferForeignAuthorizationSuccess,
  fetchTransferForeignAuthorizationFailure,
  fetchTransferForeignAccountDetailSuccess,
  fetchTransferForeignAccountDetailFailure,
  fetchTransferForeignMakeFeeSuccess,
  fetchTransferForeignMakeFeeFailure,
} from "./actions";
import {
  FETCH_TRANSFER_FOREIGN_ACCOUNT_DETAIL_REQUEST,
  FETCH_TRANSFER_FOREIGN_CREATE_REQUEST,
  FETCH_TRANSFER_FOREIGN_CONFIRM_REQUEST,
  FETCH_TRANSFER_FOREIGN_AUTHORIZATION_KEY_REQUEST,
  FETCH_TRANSFER_FOREIGN_MAKE_FEE_REQUEST,
} from "./actions.type";

import {
  fetchTransferForeignCreateService,
  fetchTransferForeignConfirmService,
  fetchTransferForeignAuthService,
  fetchTransferForeignAccountDetailService,
} from "../services/transfer-foreign.service";
import {
  FetchTransferForeignAccountDetailRequest,
  FetchTransferForeignAuthorizationRequest,
  FetchTransferForeignConfirmRequest,
  FetchTransferForeignCreateRequest,
  FetchTransferForeignMakeFeeRequest,
} from "./types";
import { ACCOUNT, RESPONSEBASE } from "app/shared/services/services-model.type";
import { getErrorEndOTP, getErrorMessage } from "app/shared/services/axios";
import { hideModal, showModal } from "app/modules/modal-management/reducer/action";

function* fetchTransferForeignAccountDetailSaga(action: FetchTransferForeignAccountDetailRequest) {
  try {
    yield put(showModal({ modalProps: { open: true }, modalType: "loading" }));
    const response: AxiosResponse<RESPONSEBASE> = yield call(() => fetchTransferForeignAccountDetailService(action));
    console.log("fetchTransferForeignAccountDetail response: ", response);
    yield put(hideModal());
    if (response.status === 200) {
      const resTransfer = response.data.RESPONSEDATA?.TRANSFER;
      const accountProfile: ACCOUNT = {
        ACCOUNTNO: resTransfer?.CREDIT_ACCOUNT_NUMBER,
        ACCOUNTNAME: resTransfer?.CREDIT_ACCOUNT_NAME,
        ACCOUNTTYPE: resTransfer?.CREDIT_ACCOUNT_TYPE,
      };
      yield put(fetchTransferForeignAccountDetailSuccess(accountProfile));
    }
  } catch (e: any | AxiosError) {
    yield put(hideModal());
    const msg = getErrorMessage(e, false);
    yield put(fetchTransferForeignAccountDetailFailure(msg));
  }
}

function* fetchTransferForeignMakeFeeSaga(action: FetchTransferForeignMakeFeeRequest) {
  try {
    yield put(showModal({ modalProps: { open: true }, modalType: "loading" }));
    const response: AxiosResponse<RESPONSEBASE> = yield call(() => fetchTransferForeignCreateService(action.payload));
    console.log("fetchTransferForeignMakeFee response: ", response);
    yield put(hideModal());
    if (response.status === 200) {
      yield put(fetchTransferForeignMakeFeeSuccess(response.data.RESPONSEDATA));
    }
  } catch (e: any | AxiosError) {
    yield put(hideModal());
    const msg = getErrorMessage(e, true);
    yield put(fetchTransferForeignMakeFeeFailure(msg));
  }
}

function* fetchTransferForeignCreateSaga(action: FetchTransferForeignCreateRequest) {
  try {
    yield put(showModal({ modalProps: { open: true }, modalType: "loading" }));
    const response: AxiosResponse<RESPONSEBASE> = yield call(() => fetchTransferForeignCreateService(action.payload));
    console.log("fetchTransferForeignCreate response: ", response);
    yield put(hideModal());
    if (response.status === 200) {
      let responseData = response.data.RESPONSEDATA;
      yield put(fetchTransferForeignCreateSuccess(responseData));
    }
  } catch (e: any | AxiosError) {
    yield put(hideModal());
    const msg = getErrorMessage(e, true);
    yield put(fetchTransferForeignCreateFailure(msg));
  }
}

function* fetchTransferForeignConfirmSaga(action: FetchTransferForeignConfirmRequest) {
  try {
    yield put(showModal({ modalProps: { open: true }, modalType: "loading" }));
    const response: AxiosResponse<RESPONSEBASE> = yield call(() => fetchTransferForeignConfirmService(action));
    console.log("fetchTransferForeignConfirm response: ", response);
    yield put(hideModal());
    if (response.status === 200) {
      let responseData = response.data.RESPONSEDATA;
      yield put(fetchTransferForeignConfirmSuccess(responseData));
    }
  } catch (e: any | AxiosError) {
    yield put(hideModal());
    const msg = getErrorMessage(e, true);
    yield put(fetchTransferForeignConfirmFailure(msg));
  }
}

function* fetchTransferForeignAuthSaga(action: FetchTransferForeignAuthorizationRequest) {
  try {
    yield put(showModal({ modalProps: { open: true }, modalType: "loading" }));
    const response: AxiosResponse<RESPONSEBASE> = yield call(() => fetchTransferForeignAuthService(action));
    console.log("fetchTransferForeignAuth response: ", response);
    yield put(hideModal());
    if (response.status === 200) {
      let responseData = response.data.RESPONSEDATA;
      yield put(fetchTransferForeignAuthorizationSuccess(responseData));
    }
  } catch (e: any | AxiosError) {
    yield put(hideModal());
    const msg = getErrorMessage(e, true);
    yield put(fetchTransferForeignAuthorizationFailure(getErrorEndOTP(e), msg));
  }
}

function* transferForeignSaga() {
  yield all([
    takeLatest(FETCH_TRANSFER_FOREIGN_ACCOUNT_DETAIL_REQUEST, fetchTransferForeignAccountDetailSaga),
    takeLatest(FETCH_TRANSFER_FOREIGN_MAKE_FEE_REQUEST, fetchTransferForeignMakeFeeSaga),
    takeLatest(FETCH_TRANSFER_FOREIGN_CREATE_REQUEST, fetchTransferForeignCreateSaga),
    takeLatest(FETCH_TRANSFER_FOREIGN_CONFIRM_REQUEST, fetchTransferForeignConfirmSaga),
    takeLatest(FETCH_TRANSFER_FOREIGN_AUTHORIZATION_KEY_REQUEST, fetchTransferForeignAuthSaga),
  ]);
}

export default transferForeignSaga;
